import gql from 'graphql-tag';
export const accountsDataQuery = gql `
  query accountsDataQuery {
    accounts {
      id
      normalizedImageUrl
      normalizedName
    }
    currentUserV2 {
      id
      email
    }
  }
`;
const useAccountsMenuData = ({ useQuery }) => useQuery(accountsDataQuery, { ssr: false, fetchPolicy: 'network-only' });
export default useAccountsMenuData;
//# sourceMappingURL=useAccountsMenuData.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
